export default (subCategoriesStr?: string): string[] => {
    const result: string[] = [];

    if (typeof (subCategoriesStr) !== "undefined") {
        const subCategories = JSON.parse(subCategoriesStr);

        for (const key in subCategories) {
            const subCategory = subCategories[key];
            result.push(subCategory);
        }
    }

    return result;
};